import { createFileRoute } from '@tanstack/react-router'
import { AuditorPopulationsListPage } from '@/components/auditor-center/AuditorPopulationsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations',
)({
  component: AuditorPopulationsListPage,
})
